var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { DESIRED_GAME_FIELD, USERNAME_FIELD, USERS_PATH } from "../../framework/firebase/DBPathConstants";
import { nanoid } from "nanoid";
import { Layer } from "../../framework/layer/Layer";
import { DataProvider } from "../../framework/layer/DataProvider";
import { sleep } from "../../util/NetworkingUtils";
export class LoginLayer extends Layer {
    constructor(firebase, isTestingMode, testingModeIndex, username, desiredGameId) {
        super([]);
        this.uid = '';
        this.firebase = firebase;
        this.isTestingMode = isTestingMode;
        this.testingModeIndex = testingModeIndex;
        this.desiredGameId = desiredGameId;
        this.username = username;
    }
    activate() {
        (() => __awaiter(this, void 0, void 0, function* () {
            yield this.login();
            this.firebase.onValue('.info/connected', (snap) => __awaiter(this, void 0, void 0, function* () {
                const isConnected = snap.exists() && snap.val();
                if (isConnected) {
                    yield this.joinGame(this.desiredGameId, this.username);
                }
            }));
            while (this.uid === '') {
                yield sleep(250);
            }
            yield this.testingModeSleep(this.testingModeIndex, this.isTestingMode);
            this.sendUpdate({
                type: 'Created',
                key: 'userId',
                oldData: null,
                newData: this.uid,
            });
        }))();
    }
    close() {
    }
    getLayerData() {
        return {
            userId: this.uid,
        };
    }
    update() {
        return null;
    }
    login() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isTestingMode) {
                return;
            }
            const auth = getAuth();
            signInAnonymously(auth).catch((error) => console.error(error));
            onAuthStateChanged(auth, (user) => {
                if (user) {
                    this.uid = user.uid;
                }
            });
            while (this.uid === '') {
                yield sleep(250);
            }
        });
    }
    joinGame(desiredGameId, username) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isTestingMode) {
                const uid = this.getTestingModeUid();
                this.uid = `${uid}${this.testingModeIndex}`;
                yield this.joinGameInternal(this.uid, desiredGameId, `${username}`);
            }
            else {
                yield this.joinGameInternal(this.uid, desiredGameId, username);
            }
        });
    }
    joinGameInternal(uid, desiredGameId, username) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.finishLogin(uid, username);
            const userPath = `${USERS_PATH}/${uid}`;
            yield this.firebase.set(`${userPath}/${DESIRED_GAME_FIELD}`, desiredGameId);
        });
    }
    finishLogin(uid, username) {
        return __awaiter(this, void 0, void 0, function* () {
            const uidUsernamePath = `${USERS_PATH}/${uid}/${USERNAME_FIELD}`;
            const uidSnap = yield this.firebase.get(uidUsernamePath);
            if (uidSnap.exists())
                throw new Error('Current UID is already taken on the server!');
            yield this.firebase.onDisconnect(uidUsernamePath).remove();
            yield this.firebase.set(uidUsernamePath, username);
        });
    }
    getTestingModeUid() {
        const testingModeUidKey = 'testingModeUid';
        const savedId = localStorage.getItem(testingModeUidKey);
        if (savedId !== null) {
            return savedId;
        }
        const newId = `test~${nanoid(6)}`;
        localStorage.setItem(testingModeUidKey, newId);
        return newId;
    }
    testingModeSleep(gameIndex, isTestingMode) {
        return __awaiter(this, void 0, void 0, function* () {
            if (isTestingMode && gameIndex > 0) {
                yield sleep(500 * gameIndex);
            }
        });
    }
}
export class UserIdProvider extends DataProvider {
    constructor(inLayer) {
        super(inLayer, ['userId']);
    }
}
//# sourceMappingURL=LoginLayer.js.map